import { render, staticRenderFns } from "./newEntrepreneurshipEdition.vue?vue&type=template&id=16d7350d"
import script from "./newEntrepreneurshipEdition.vue?vue&type=script&lang=js"
export * from "./newEntrepreneurshipEdition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports